import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import { Element } from 'react-scroll';

const LandingDemoFeatures = () => {
    return (
        <Element
            name="features"
            className="landing-demo-features edu-section-gap bg-color-white"
        >
            <div className="container eduvibe-animated-shape">
                <div className="row">
                    <div className="col-lg-12">
                        <ScrollAnimation animateIn="fadeInUp" animateOut="fadeInOut" className="pre-section-title text-center" animateOnce={ true }>
                            <span className="color-primary pretitle">AWESOME FEATURES</span>
                            <h3 className="title">EduVibe Best Features</h3>
                        </ScrollAnimation>
                    </div>
                </div>

                <div className="row g-5 mt--10">
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="demo-feature mt--20">
                            <div className="inner">
                                <div className="icon">
                                    <img src="/images/landing-demo/feature-01.png" alt="Preview Images" />
                                </div>
                                <h6 className="title">Animation</h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="demo-feature mt--20">
                            <div className="inner">
                                <div className="icon">
                                    <img src="/images/landing-demo/feature-02.png" alt="Preview Images" />
                                </div>
                                <h6 className="title">Speed Performance</h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="demo-feature mt--20">
                            <div className="inner">
                                <div className="icon">
                                    <img src="/images/landing-demo/feature-03.png" alt="Preview Images" />
                                </div>
                                <h6 className="title">Built on Bootstrap(5.x)</h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="demo-feature mt--20">
                            <div className="inner">
                                <div className="icon">
                                    <img src="/images/landing-demo/feature-04.png" alt="Preview Images" />
                                </div>
                                <h6 className="title">Slick Slider</h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="demo-feature mt--20">
                            <div className="inner">
                                <div className="icon">
                                    <img src="/images/landing-demo/feature-05.png" alt="Preview Images" />
                                </div>
                                <h6 className="title">Google Fonts</h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="demo-feature mt--20">
                            <div className="inner">
                                <div className="icon">
                                    <img src="/images/landing-demo/feature-06.png" alt="Preview Images" />
                                </div>
                                <h6 className="title">Mouse-move Parallax Effect</h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="demo-feature mt--20">
                            <div className="inner">
                                <div className="icon">
                                    <img src="/images/landing-demo/feature-07.png" alt="Preview Images" />
                                </div>
                                <h6 className="title">Parallax Effect</h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="demo-feature mt--20">
                            <div className="inner">
                                <div className="icon">
                                    <img src="/images/landing-demo/feature-08.png" alt="Preview Images" />
                                </div>
                                <h6 className="title">BoxIcons</h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="demo-feature mt--20">
                            <div className="inner">
                                <div className="icon">
                                    <img src="/images/landing-demo/feature-09.png" alt="Preview Images" />
                                </div>
                                <h6 className="title">Fast 5 Star Support</h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="demo-feature mt--20">
                            <div className="inner">
                                <div className="icon">
                                    <img src="/images/landing-demo/feature-10.png" alt="Preview Images" />
                                </div>
                                <h6 className="title">Smooth Transition Effects</h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="demo-feature mt--20">
                            <div className="inner">
                                <div className="icon">
                                    <img src="/images/landing-demo/feature-11.png" alt="Preview Images" />
                                </div>
                                <h6 className="title">Fully Responsive Layouts</h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="demo-feature mt--20">
                            <div className="inner">
                                <div className="icon">
                                    <img src="/images/landing-demo/feature-12.png" alt="Preview Images" />
                                </div>
                                <h6 className="title">Browser Compatibility</h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="demo-feature mt--20">
                            <div className="inner">
                                <div className="icon">
                                    <img src="/images/landing-demo/feature-13.png" alt="Preview Images" />
                                </div>
                                <h6 className="title">Developer Friendly</h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="demo-feature mt--20">
                            <div className="inner">
                                <div className="icon">
                                    <img src="/images/landing-demo/feature-14.png" alt="Preview Images" />
                                </div>
                                <h6 className="title">Quick Support</h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="demo-feature mt--20">
                            <div className="inner">
                                <div className="icon">
                                    <img src="/images/landing-demo/feature-15.png" alt="Preview Images" />
                                </div>
                                <h6 className="title">Well Documented</h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="demo-feature mt--20">
                            <div className="inner">
                                <div className="icon">
                                    <img src="/images/landing-demo/feature-16.png" alt="Preview Images" />
                                </div>
                                <h6 className="title">Free Lifetime Updates</h6>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="shape-wrapper">
                    <div className="shape-dot-wrapper shape-wrapper d-xl-block d-none">
                        <div className="shape-image shape-image-1">
                            <img src="/images/shapes/shape-04-08.png" alt="Shape Thumb" />
                        </div>
                        <div className="shape-image shape-image-2">
                            <img src="/images/shapes/shape-03-02.png" alt="Shape Thumb" />
                        </div>
                        <div className="shape-image shape-image-3">
                            <img src="/images/shapes/shape-11-10.png" alt="Shape Thumb" />
                        </div>
                    </div>
                </div>
            </div>
        </Element>
    )
}

export default LandingDemoFeatures;